import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import cfg from "./cfg"
import _ from 'lodash'
import IdleVue from "idle-vue";

// Vue.prototype.$cfg = cfg
Vue.config.productionTip = false

// Global variables
Vue.prototype.$cfg = cfg
axios.defaults.withCredentials = true;

// `baseURL` is prepended to URLs passed to axios
axios.defaults.baseURL = cfg.API_URL

// POST with JSON content type
axios.defaults.headers.post['Content-Type'] = 'application/json'

// It gives you easy global access to it instead use import
Vue.prototype.$axios = axios.create()

Vue.prototype.$_ = _

// idle-vue setup to track when client is active or idle
const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: process.env.VUE_APP_IDLE_TIME
});

store.dispatch("InitStore").then(startVue);

function startVue() {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}